export default "__VITE_ASSET__Bt1MhYP5__"